module.exports = __webpack_public_path__ + "static/bett1aces_ysl_003-84a963ee452fe233a81f77eea0701563.gif";